import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface IProps {
  isShow: boolean;
  isSaving?: boolean;
  onCreate: (name: string, email: string, password: string) => void;
  onClose: () => void;
}

const AccountCreateModal = ({ isShow, isSaving, onCreate, onClose }: IProps) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { t } = useTranslation();

  // 열릴 때마다 입력 초기화
  useEffect(() => {
    if (isShow) {
      setName("");
      setEmail("");
      setPassword("");
    }
  }, [isShow]);

  const isValid = !!(name && email && password);

  return (
    <Modal show={isShow} onHide={() => onClose()} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-5 fw-bold">새 계정 등록</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* 브라우저가 로그인 폼으로 인식해 본인 계정을 자동완성하는 것 방지 */}
        <Form autoComplete="off">
        <Form.Group className="mb-3">
          <Form.Label className="small fw-semibold">이름 <span className="text-danger">*</span></Form.Label>
          <Form.Control value={name} placeholder="예: 중국애니메이트" onChange={(e) => setName(e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label className="small fw-semibold">아이디(이메일) <span className="text-danger">*</span></Form.Label>
          <Form.Control
            className="font-monospace"
            value={email}
            placeholder="animate-ch@youngint.com"
            autoComplete="off"
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label className="small fw-semibold">비밀번호 <span className="text-danger">*</span></Form.Label>
          <Form.Control
            className="font-monospace"
            type="password"
            value={password}
            placeholder="비밀번호 입력"
            autoComplete="new-password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
        </Form>
        <div className="text-muted small mt-3">권한(국가 · 모드)은 계정 생성 후 목록에서 선택해 부여합니다.</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onClose()} disabled={isSaving}>{t("button-close")}</Button>
        <Button variant="primary" onClick={() => onCreate(name, email, password)} disabled={!isValid || isSaving}>
          {isSaving ? "등록 중…" : "계정 등록"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AccountCreateModal;
